export const TEST_ID = {
  contentSearchFilter: 'contentSearchFilter',
};

export const FILE_TYPES = {
  pdf: 'pdf',
  xlsx: 'xlsx',
};
